// The booking wizard's wording in Korean; keys match en.ts. Machine-drafted, flagged for native review.
import type { en } from "./en";

export const ko = {
  // Page
  schedule_appointment: "예약하기",
  powered_by: "제공",

  // Patient type
  new_or_existing: "신규 환자이신가요, 기존 환자이신가요?",
  new_patient: "신규 환자",
  existing_patient: "기존 환자",
  first_time_visiting: "이 병원은 처음 방문합니다",
  been_here_before: "이전에 방문한 적이 있습니다",

  // Appointment info
  what_type: "어떤 종류의 예약인가요?",
  no_types_available: "현재 온라인으로 예약할 수 있는 진료 유형이 없습니다.",
  minutes: "%{count}분",
  additional_info: "어떤 문제나 불편 사항을 상담받고 싶으신가요?",
  describe_concern: "불편 사항을 설명해 주세요...",

  // Provider
  pick_provider: "담당 의사 선택",
  loading_providers: "담당 의사를 불러오는 중...",
  failed_load_providers: "담당 의사를 불러오지 못했습니다. 다시 시도해 주세요.",
  any_provider: "상관없음",
  show_all_available: "가능한 모든 시간 보기",
  no_availability: "가능한 시간 없음",

  // Time
  pick_a_time: "시간 선택",
  finding_times: "가능한 시간을 찾는 중...",
  no_times_for_date: "이 날짜에는 가능한 시간이 없습니다",
  slot_just_taken: "죄송합니다. 그 시간은 방금 예약되었습니다. 다른 시간을 선택해 주세요.",
  jump_to_next: "다음 가능한 시간으로 이동",
  morning: "오전",
  afternoon: "오후",
  cant_find_time: "원하는 시간이 없으신가요? 병원으로 전화 주시면 도와드리겠습니다.",

  // Patient info
  your_information: "환자 정보",
  first_name: "이름",
  last_name: "성",
  preferred_name: "선호하는 이름",
  optional: "선택 사항",
  date_of_birth: "생년월일",
  phone_number: "전화번호",
  required: "필수",
  invalid_phone: "올바른 10자리 전화번호를 입력해 주세요",
  min_age: "환자는 만 5세 이상이어야 합니다",
  future_date: "미래 날짜일 수 없습니다",
  referral_question: "저희를 어떻게 알게 되셨나요?",
  referral_prompt: "항목 선택",
  referral_detail_who: "누가 소개해 주셨나요?",
  referral_detail_other: "저희를 어떻게 알게 되셨는지 알려 주세요",
  referral_detail_optional: "추가 정보(선택 사항)",
  verification_disclaimer: "이 번호로 인증 코드가 전송됩니다.",
  phone_verified: "전화번호 인증 완료",
  verifying: "인증 중...",
  verify: "인증",
  invalid_code: "잘못된 코드입니다. 다시 시도해 주세요.",
  sending: "전송 중...",
  resend_code: "코드 다시 보내기",
  email: "이메일",
  send_verification: "인증 코드 보내기",
  sending_code: "코드 전송 중...",

  // Insurance
  insurance_info: "보험 정보",
  have_insurance: "보험이 있으신가요?",
  insurance_changed: "마지막 방문 이후 보험이 바뀌었나요?",
  no_insurance_change: "변경 없음",
  yes: "예",
  no: "아니요",
  insurance_name: "보험사 이름",
  subscriber_name: "가입자 이름",
  subscriber_dob: "가입자 생년월일",
  subscriber_id: "가입자 번호",
  group_number: "그룹 번호",
  select_option: "항목을 선택해 주세요",
  card_photo_title: "보험 카드 사진",
  card_photo_hint: "방문 전에 보장 내용을 확인할 수 있도록 카드 양면 사진을 추가해 주세요.",
  card_front: "카드 앞면",
  card_back: "카드 뒷면",
  add_photo: "사진 추가",
  uploading_photo: "사진 업로드 중...",
  remove_photo: "삭제",
  card_upload_failed: "사진을 추가하지 못했습니다. 다시 시도하거나 사진 없이 계속할 수 있습니다.",
  card_try_again: "다시 시도",

  // Review
  review_appointment: "예약 내용 확인",
  appointment_details: "예약 정보",
  type_label: "유형",
  provider: "담당 의사",
  any_available: "가능한 의사 누구나",
  date_and_time: "날짜 및 시간",
  notes: "메모",
  patient_information: "환자 정보",
  name: "이름",
  phone: "전화번호",
  insurance: "보험",
  subscriber: "가입자",
  subscriber_id_label: "가입자 번호",
  group_hash: "그룹 번호",
  no_insurance: "보험 없음",
  card_photos: "카드 사진",
  card_front_short: "앞면",
  card_back_short: "뒷면",
  waitlist: "더 이른 시간이 나오면 연락해 주세요",
  consent_prefix: "예약하시면 ",
  terms: "이용 약관",
  consent_and: " 및 ",
  privacy: "개인정보 처리방침",
  consent_suffix:
    "에 동의하는 것으로 간주됩니다. 전화번호를 제공하시면 문자 메시지 수신에 동의하는 것입니다. 메시지 및 데이터 요금이 부과될 수 있습니다.",
  scheduling: "예약 중...",
  schedule_appointment_btn: "예약하기",
  continue_to_payment: "결제로 계속",

  // Deposit
  deposit_title: "보증금 결제",
  deposit_explainer:
    "보증금 %{amount}을 결제하면 이 예약이 확정됩니다. 보증금은 계정에 적립되어 진료비에 적용됩니다. 예약에 불참하시면 보증금을 돌려받을 수 없습니다.",
  deposit_due: "보증금",
  deposit_card_fee: "카드 수수료",
  deposit_card_fee_notice:
    "신용카드 결제에는 %{percentage}%의 처리 수수료가 포함됩니다. 체크카드에는 수수료가 없습니다.",
  deposit_total: "합계",
  deposit_loading: "안전 결제를 불러오는 중...",
  deposit_paying: "처리 중...",
  deposit_pay_and_book: "결제 후 예약",
  deposit_card_error: "보증금을 결제할 수 없었습니다. 카드를 확인한 후 다시 시도해 주세요.",
  deposit_unavailable: "안전 결제를 불러올 수 없었습니다. 병원으로 전화해 주세요.",
  deposit_needs_hold: "이 시간을 확보할 수 없었습니다. 시간을 다시 선택해 주세요.",
  deposit_processing:
    "결제가 아직 확인 중입니다. 다시 결제하지 마세요 — 병원에서 곧 예약을 확정해 드립니다.",

  // Confirmation
  appointment_requested: "예약 요청을 받았습니다!",
  confirm_message:
    "병원에서 검토한 후 확정 안내를 보내 드립니다. 추가 정보가 필요하면 저희 팀에서 연락드리겠습니다.",
  date: "날짜",
  time: "시간",
  add_to_google: "Google 캘린더에 추가",
  download_ics: "캘린더 파일 다운로드(.ics)",
  questions_call: "문의 사항은 전화해 주세요:",

  // Errors
  network_error: "문제가 발생했습니다. 다시 시도해 주세요.",

  // Common
  back: "뒤로",
  continue: "계속",
  review: "확인",

  // Step labels
  step_appointment: "예약",
  step_provider: "담당 의사",
  step_time: "시간",
  step_your_info: "환자 정보",
  step_insurance: "보험",
} as const satisfies Record<keyof typeof en, string>;
